<template>
  <div class="content-layout">
    <header class="content-header">
      <RouterLink to="/">
        <LogoType />
      </RouterLink>
      <RouterLink to="/" class="content-link home-link">
        <ArrowLeft class="arrow-left" />
        Home
      </RouterLink>
      <HeaderText tag="h1" class="content-title"
        ><slot name="title"
      /></HeaderText>
    </header>
    <main class="content-body">
      <slot />
    </main>
    <ul class="content-links">
      <li
        class="content-link-container"
        v-for="{ text, to } in links"
        :key="text"
      >
        <RouterLink :to="to" class="content-link">
          {{ text }}
          <ArrowRight class="arrow-right" />
        </RouterLink>
      </li>
      <li class="content-link-container">
        <SocialSharing class="content-link" />
      </li>
    </ul>
  </div>
</template>

<script>
import ArrowLeft from '@/assets/arrow-left.svg';
import ArrowRight from '@/assets/arrow-right.svg';
import HeaderText from '@/components/header-text';
import LogoType from '@/components/logo-type';
import SocialSharing from '@/components/social-sharing';
import { RouterAliases } from '@/router';

export default {
  components: {
    ArrowLeft,
    ArrowRight,
    HeaderText,
    LogoType,
    SocialSharing,
  },
  computed: {
    links() {
      return [
        {
          text: 'FAQ',
          to: {
            name: RouterAliases.FAQ,
          },
        },
        {
          text: 'Contact Us',
          to: {
            name: RouterAliases.CONTACT,
          },
        },
      ].filter(link => link.to.name !== this.$route.name);
    },
  },
};
</script>

<style lang="scss" scoped>
$breakpoint: 1024px;

.content-layout {
  background: var(--light-blue);
  color: var(--white);
  height: auto;
  min-height: 100vh;
  padding: var(--page-padding);

  @media screen and (min-width: $breakpoint) {
    column-gap: 100px;
    display: grid;
    grid-template-columns:
      calc(450px - (2 * var(--page-padding)))
      minmax(auto, 80ch);
    grid-template-rows: 1fr auto;
  }
}

.content-body {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;

  @media screen and (min-width: $breakpoint) {
    grid-area: 1 / 2 / 3 / 3;
  }

  /deep/ {
    h2 {
      margin-bottom: 20px;
      margin-top: 1.5em;

      &:first-child {
        margin-top: 0;
      }
    }

    p,
    ol {
      color: var(--white-transparent);

      strong {
        color: var(--white);
      }
    }

    a {
      color: var(--yellow);
      font-weight: bold;
    }

    ol {
      counter-reset: item;
      list-style: none;
      margin-bottom: 1em;
      padding: 0 0 0 40px;

      li {
        counter-increment: item;
        margin-bottom: 1em;

        &::before {
          content: counter(item) '. ';
          color: var(--white);
          font-weight: bold;
        }
      }
    }
  }
}

.content-link {
  align-items: baseline;
  border-top: 1px solid var(--white-transparent-lighter);
  color: var(--white);
  display: flex;
  justify-content: space-between;
  padding: 12px 0px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;

  &.social-sharing {
    align-items: center;
  }
}

.home-link {
  display: none;

  @media screen and (min-width: $breakpoint) {
    border-bottom: 1px solid var(--white-transparent-lighter);
    justify-content: flex-start;
    display: flex;
    margin: 72px 0 0;
  }
}

.content-title {
  margin: 24px 0;
}

.arrow-left {
  color: var(--white);
  margin-right: 16px;
}

.content-links {
  list-style: none;
  margin: 40px 0 0;
  padding: 0;
}

.content-link-container {
  margin: 0;
  padding: 0;
}
</style>
